export default class ValidationResponse {
  constructor(obj) {
    if (!obj) obj = {};
    this.valid = obj.valid ? obj.valid : false;
    this.actionId = obj.actionId ? obj.actionId : 0;
  }
}
